import React from 'react'
import cx from 'classnames'
// TODO: Try to remove `react-motion` and do this with CSS animation
import { Motion, spring } from 'react-motion'
import ButtonIcon from './ButtonIcon'
import config from '../config'

const styles = `
  .widgetButtonWrapper {
    display: block;
    position: fixed;
    right: 20px;
    bottom: 20px;
    border-radius: 50% !important;
    width: 60px;
    height: 60px;
    line-height: 60px;
    max-width: 60px;
    max-height: 60px;
    min-width: 0;
    min-height: 0;
    // Will be overwritten with style property
    background: #008e95;
    z-index: 999991;
  }

  .widgetButtonWrapperActiveAndFullSize {
    display: none;
  }

  .widgetButtonInner {
    outline: 0;
    display: block;
    background: transparent;
    border: 0;
    width: 100%;
    height: 60px;
    line-height: 60px;
    // vertical-align: middle;
    cursor: pointer;
    margin: 0 auto;
  }
`

const Button = ({ colors, active, isActiveAndFullSize, onClick }) => {
  const buttonStyle =
    colors && colors.hasOwnProperty('widgetButtonColor')
      ? {
          background: colors.widgetButtonColor,
        }
      : {}

  const buttonClassName = cx({
    ['widgetButtonWrapper']: true,
    ['widgetButtonWrapperActiveAndFullSize']: isActiveAndFullSize,
  })

  return (
    <>
      <style>{styles}</style>
      <span className={buttonClassName} style={buttonStyle}>
        <Motion
          defaultStyle={{
            opacity: 0,
            scale: 0,
          }}
          style={{
            opacity: spring(1, config.presets.default),
            scale: spring(1, config.presets.default),
          }}
        >
          {interpolatingStyles => (
            <span
              className={'widgetButtonInner'}
              onClick={onClick}
              style={{
                opacity: interpolatingStyles.opacity,
                transform: `scale(${interpolatingStyles.scale})`,
              }}
            >
              <ButtonIcon isActive={active} type='open' />
              <ButtonIcon isActive={active} type='close' />
            </span>
          )}
        </Motion>
      </span>
    </>
  )
}

export default Button
